<form class="fix-editor">
  <mat-form-field class="ag-row fix-mat-form">
    <input #letterInput matInput tabindex="0"
           [formControl]="formControl"
           [errorStateMatcher]="matcher">
  </mat-form-field>
</form>
